var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationalKiosks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f3faff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59,48.36c-.41,0-.75-.34-.75-.75v-26.19c0-.41.34-.75.75-.75s.75.34.75.75v26.19c0,.41-.34.75-.75.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1,48.36c-.41,0-.75-.34-.75-.75v-26.19c0-.41.34-.75.75-.75s.75.34.75.75v26.19c0,.41-.34.75-.75.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49.64,51.81c-.08,0-.17-.01-.25-.04l-19.57-6.83s-.05-.01-.08-.02l-9.63-3.34c-.39-.14-.6-.56-.46-.95.14-.39.56-.6.96-.46l9.57,3.32s.05.01.08.02l19.63,6.85c.39.14.6.56.46.96-.11.31-.4.5-.71.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.29,55.26c-.08,0-.17-.01-.25-.04l-29.5-10.29c-.31-.1-.53-.38-.53-.72,0-.41.33-.75.74-.75h.02c.08,0,.17.01.25.04l29.52,10.3c.39.14.6.56.46.96-.11.31-.4.5-.71.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.36,51.81c-.31,0-.6-.19-.71-.5-.14-.39.07-.82.46-.96l19.64-6.85s.06-.02.08-.02l9.55-3.32c.39-.14.82.07.95.46.14.39-.07.82-.46.95l-9.62,3.34s-.06.02-.08.02l-19.57,6.83c-.08.03-.17.04-.25.04Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.71,55.26c-.31,0-.6-.19-.71-.5-.14-.39.07-.82.46-.96l29.52-10.3c.48-.17,1.01.21,1.01.71,0,.36-.25.66-.58.73l-29.45,10.28c-.08.03-.17.04-.25.04Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m58.99,48.36c-.08,0-.17-.01-.25-.04l-28.75-10.02L1.25,48.31c-.39.14-.82-.07-.96-.46-.14-.39.07-.82.46-.95l28.99-10.1c.16-.06.33-.06.49,0l28.99,10.1c.39.14.6.56.46.95-.11.31-.4.5-.71.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30,59.04c-.09,0-.18-.02-.26-.05L.74,48.31c-.3-.11-.5-.41-.49-.73.01-.32.23-.6.54-.69.17-.05.35-.03.5.03l28.71,10.58,28.67-10.56c.16-.08.35-.1.53-.04.31.09.54.37.55.69s-.18.62-.49.73l-29,10.68c-.08.03-.17.05-.26.05Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m53.37,25.75c-.41,0-.75-.34-.75-.75V7.68c0-.41.34-.75.75-.75s.75.34.75.75v17.32c0,.41-.34.75-.75.75Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m6.63,31.57c-.41,0-.75-.34-.75-.75v-13.44c0-.41.34-.75.75-.75s.75.34.75.75v13.44c0,.41-.34.75-.75.75Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40,33.75h-20c-.41,0-.75-.34-.75-.75v-7c0-.41.34-.75.75-.75h20c.41,0,.75.34.75.75v7c0,.41-.34.75-.75.75Zm-19.25-1.5h18.5v-5.5h-18.5v5.5Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40,26.75h-20c-.41,0-.75-.34-.75-.75v-15c0-.41.34-.75.75-.75h20c.41,0,.75.34.75.75v15c0,.41-.34.75-.75.75Zm-19.25-1.5h18.5v-13.5h-18.5v13.5Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m44,11.75h-28c-.34,0-.64-.23-.72-.56-.09-.33.06-.67.35-.84L29.63,2.33c.23-.13.52-.13.75,0l14,8.02c.29.17.44.52.35.84-.09.33-.38.56-.72.56Zm-25.18-1.5h22.36l-11.18-6.41-11.18,6.41Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m36,23.75h-12c-.41,0-.75-.34-.75-.75v-3c0-3.72,3.03-6.75,6.75-6.75s6.75,3.03,6.75,6.75v3c0,.41-.34.75-.75.75Zm-11.25-1.5h10.5v-2.25c0-2.9-2.36-5.25-5.25-5.25s-5.25,2.35-5.25,5.25v2.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationalKiosks);
export default __webpack_public_path__ + "static/media/Informational Kiosks.d99c2c3fd43654338a06466e1b40b027.svg";
export { ForwardRef as ReactComponent };